import { inject, observer } from 'mobx-react';
import React from 'react'
import ModalWrapper from './ModalWrapper';
import { ReactComponent as CloseIcon } from "../../svg/close.svg";

@inject('store') @observer
class UpgradeModal extends React.Component {

  closeModal(){
    const { store } = this.props
    store.toggleUpgradeModal(null, false)
  }

  render(){
    const { upgradeModal, upgradeModalContent } = this.props.store
    if(!upgradeModal && !upgradeModalContent){
      return (
        <div />
      )
    }
    const { 
      heading,
      subheading,
      features,
      cta,
      image,
      featureHeading,
      actionText,
      action,
      customImage,
      highImage
    } = upgradeModalContent
    return (
      <ModalWrapper
        modalClass='upgrade-modal'
        close={this.closeModal.bind(this)}
      >
        <div className='upgrade-modal__wrapper row no-gutters'>
          <div className='col-sm-12 col-md-6 upgrade-modal__text'>
            <h2 className='upgrade-modal__heading'>
              {heading}
            </h2>
            <p className='upgrade-modal__subheading'>
              {subheading}
            </p>
            {
              typeof(features) === 'object' && features.length ? (
                <>
                  <h5 className='upgrade-modal__feature-heading'>
                    {featureHeading}
                  </h5>
                  <ul className='upgrade-modal__features'>
                    {
                      features.map((feature, idx) => (
                        <li 
                          key={idx} 
                          className='upgrade-modal__features__feature'
                        >
                          {feature.text}
                        </li>
                      ))
                    }
                  </ul>
                </>
              )
              :
              (
                <p className='text-features'>{features}</p>
              )
            }
            {
              cta ? (
                <h5 className='upgrade-modal__cta-text'>
                  {cta}
                </h5>
              )
              :
              undefined
            }
            {
              action && typeof(action) === 'function' ? (
                <button 
                  onClick={action}
                  className='btn btn-primary w-100 upgrade-modal__cta-btn'
                >
                  {actionText}
                </button>
              )
              :
              undefined
            }
          </div>
          <div className='col-xs-0 col-md-6 upgrade-modal__image-wrapper'>
            {
              customImage ? (
                <div className='upgrade-modal__custom-wrapper'>
                  <img className={`upgrade-modal__custom-image${highImage ? ' high' : ''}`} src={image} />
                </div>
              )
              :
              (
                <img className='upgrade-modal__image' src={image} />
              )
            }
            <CloseIcon className='close-icon cursor-pointer' onClick={this.closeModal.bind(this)} />
          </div>
        </div>
      </ModalWrapper>
    )
  }

}

export default UpgradeModal